module.exports = __webpack_public_path__ + "static/media/20ECE31.c438ff26.jpg";